import React from "react";
import { OuterContainer } from "../components/OuterContainer";
import { InnerContainer } from "../components/InnerContainer";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { LinkButton } from "../../common/LinkButton";
import { MOBILIC_BLUE } from "common/utils/theme";

const useStyles = makeStyles((theme) => ({
  highlightedText: {
    color: MOBILIC_BLUE,
  },
}));

export function SoftwareSection() {
  const classes = useStyles();

  return (
    <OuterContainer grayBackground>
      <InnerContainer>
        <Stack direction="column" rowGap={4}>
          <Typography variant="h3" component="h2">
            Je suis{" "}
            <span className={classes.highlightedText}>
              éditeur de logiciels
            </span>
            , pourquoi m’interconnecter avec l’API Mobilic ?
          </Typography>
          <Box>
            <ul>
              <li>
                Une mise en conformité réglementaire de votre logiciel métier
              </li>
              <li>
                L’utilisation d’un seul logiciel par les entreprises : le vôtre
              </li>
              <li>Moins de gestion administrative pour vos clients</li>
            </ul>
          </Box>
          <LinkButton
            priority="primary"
            size="medium"
            to="https://developers.mobilic.beta.gouv.fr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Découvrir l’API
          </LinkButton>
        </Stack>
      </InnerContainer>
    </OuterContainer>
  );
}
